import React, { useEffect, useMemo, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Row, Col } from 'styled-bootstrap-grid';
import { MdKeyboardArrowRight } from 'react-icons/md';

import api from '../../services/api';

import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import Breadcrumbs from '../../containers/Breadcrumbs';

import Card from '../../components/Card';
import Datatable from '../../components/Datatable';
import Button from '../../components/Button';
import DropdownButton from '../../components/DropdownButton';

interface studentData {
  id: string;
  created_at: string;
  full_name: string;
  email: string;
  cpf: string;
  avatar_url: string;
}

interface columnData {
  label: string;
  field:
    | 'id'
    | 'created_at'
    | 'full_name'
    | 'created_at'
    | 'email'
    | 'cpf'
    | 'avatar_url';
  transform?(value: string, row?: studentData): string | React.ReactElement;
}

const Student: React.FC = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState('');
  const [pageIndex, setPageIndex] = useState(0);
  const [maxPages, setMaxPages] = useState(0);

  const [showingFrom, setShowingFrom] = useState(0);
  const [showingTo, setShowingTo] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [data, setData] = useState<studentData[]>([]);

  const columns = useMemo<columnData[]>(
    () => [
      {
        label: 'Cadastro',
        field: 'created_at',
        transform: created_at => {
          return new Date(created_at).toLocaleString('pt-BR');
        },
      },
      {
        label: 'Nome',
        field: 'full_name',
        transform: (full_name: string, row) => {
          return (
            <div>
              <img src={row?.avatar_url} alt={full_name} />
              <span>{full_name}</span>
            </div>
          );
        },
      },
      {
        label: 'E-mail',
        field: 'email',
      },
      {
        label: 'CPF',
        field: 'cpf',
      },
      {
        label: '',
        field: 'id',
        transform: id => (
          <DropdownButton>
            <ul>
              <li>
                <Link to={`/alunos/visualizar/${id}`}>
                  <MdKeyboardArrowRight size={18} />
                  Visualizar
                </Link>
              </li>
            </ul>
          </DropdownButton>
        ),
      },
    ],
    [],
  );

  useEffect(() => {
    async function loadData() {
      try {
        setLoading(true);

        const response = await api.get('/students', {
          params: { pageIndex, search },
        });

        setMaxPages(response.data.maxPages);
        setShowingFrom(response.data.showingFrom);
        setShowingTo(response.data.showingTo);
        setTotalRecords(response.data.totalRecords);
        setData(response.data.records);
      } catch (error) {
        // console.log(error);
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [pageIndex, search]);

  return (
    <>
      <Header />

      <Container style={{ flex: 1 }}>
        <Breadcrumbs title="Alunos" items={[{ title: 'Alunos' }]}>
          <Button
            color="secondary"
            onClick={() => history.push('/alunos/cadastrar')}
          >
            Cadastrar aluno
          </Button>
        </Breadcrumbs>

        <Row>
          <Col md={12}>
            <Card>
              <Datatable
                loading={loading}
                columns={columns}
                showingTo={showingTo}
                showingFrom={showingFrom}
                totalRecords={totalRecords}
                pageIndex={pageIndex}
                maxPages={maxPages}
                setPageIndex={(value: number) => setPageIndex(value)}
                setSearch={(value: string) => setSearch(value)}
              >
                {data.map(row => (
                  <tr key={row.id}>
                    {columns.map(column => (
                      <td key={column.field}>
                        {column.transform
                          ? column.transform(row[column.field], row)
                          : row[column.field]}
                      </td>
                    ))}
                  </tr>
                ))}
                {!data.length && (
                  <tr>
                    <td colSpan={columns.length}>Nenhum registro encontrado</td>
                  </tr>
                )}
              </Datatable>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default Student;
